import { Popover } from '@mui/material';
import { type ReactNode } from 'react';

interface ToolbarPopoverProps {
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    /** A fixed paper width, for a panel its content should not size. */
    width?: number;
    children: ReactNode;
}

/**
 * The options panel a toolbar button opens beneath itself, anchored to its
 * bottom centre in the viewer's glass-overlay style, alike for every tool.
 */
export default function ToolbarPopover({
    open,
    anchorEl,
    onClose,
    width,
    children,
}: ToolbarPopoverProps) {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            slotProps={{
                paper: {
                    sx: (theme) => ({
                        ...theme.mixins.floatingSurface,
                        mt: 1,
                        p: 1.5,
                        width,
                        color: 'rgba(255, 255, 255, 0.85)',
                    }),
                },
            }}
        >
            {children}
        </Popover>
    );
}
